(function () {
  var btn = document.querySelector('.menu-btn'), nav = document.getElementById('mobile-nav');
  if (btn && nav) btn.addEventListener('click', function () {
    var open = nav.hasAttribute('hidden');
    nav.toggleAttribute('hidden', !open);
    btn.setAttribute('aria-expanded', open);
  });

  var popup = document.getElementById('popup');
  if (popup) {
    var seen = false;
    try { seen = sessionStorage.getItem('popup_seen'); } catch (e) {}
    var posted = /[?&]form_type=customer/.test(location.search) || /contact_posted/.test(location.search);
    if (!seen && !posted && !(window.Shopify && Shopify.designMode)) {
      setTimeout(function () { popup.hidden = false; }, (+popup.dataset.delay || 6) * 1000);
    }
    var close = function () {
      popup.hidden = true;
      try { sessionStorage.setItem('popup_seen', '1'); } catch (e) {}
    };
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
  }
})();

/* Rocket back-to-top */
(function () {
  var rocket = document.getElementById('rocket');
  if (!rocket) return;
  function onScroll() {
    var y = window.scrollY;
    rocket.classList.toggle('show', y > 500);
    if (y <= 500) rocket.classList.remove('launch');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  rocket.addEventListener('click', function () {
    rocket.classList.add('launch');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* Hero headline effect. Change 'type' to 'glitch' or 'none' to switch. */
(function () {
  var HERO_EFFECT = 'type';
  var LOOP = true;

  var h = document.querySelector('.hero h1');
  if (!h || HERO_EFFECT === 'none') return;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var text = h.textContent.trim();
  h.setAttribute('aria-label', text);

  if (HERO_EFFECT === 'glitch') {
    h.innerHTML = '<span class="glitch" aria-hidden="true">' + text + '</span>';
    return;
  }

  h.style.minHeight = h.offsetHeight + 'px';
  var introVisible = document.getElementById('intro') && !document.documentElement.classList.contains('no-intro');
  var i = 0, dir = 1;

  function render() {
    h.innerHTML = '<span aria-hidden="true">' + text.slice(0, i) + '</span><span class="type-cursor" aria-hidden="true"></span>';
  }
  function step() {
    render();
    if (dir === 1 && i === text.length) {
      if (!LOOP) return;
      dir = -1;
      return setTimeout(step, 2200);
    }
    if (dir === -1 && i === 0) {
      dir = 1;
      return setTimeout(step, 600);
    }
    i += dir;
    setTimeout(step, dir === 1 ? 95 : 40);
  }

  h.innerHTML = '<span class="type-cursor" aria-hidden="true"></span>';
  setTimeout(step, introVisible ? 3200 : 400);
})();

/* Glowing cursor trail */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.createElement('canvas');
  canvas.className = 'cursor-trail';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
  function resize() {
    w = window.innerWidth; h = window.innerHeight;
    canvas.width = w * dpr; canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  var mx = 0, my = 0, x = 0, y = 0, active = false, lastX = 0, lastY = 0;
  var trail = [], sparks = [];

  document.addEventListener('mousemove', function (e) {
    mx = e.clientX; my = e.clientY;
    if (!active) { x = mx; y = my; lastX = mx; lastY = my; active = true; }
  });
  document.documentElement.addEventListener('mouseleave', function () { active = false; });

  function glow(px, py, r, a) {
    var g = ctx.createRadialGradient(px, py, 0, px, py, r);
    g.addColorStop(0, 'rgba(255,255,255,' + a + ')');
    g.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = g;
    ctx.beginPath(); ctx.arc(px, py, r, 0, 6.2832); ctx.fill();
  }

  function frame() {
    ctx.clearRect(0, 0, w, h);

    if (active) {
      x += (mx - x) * 0.3;
      y += (my - y) * 0.3;
      trail.push({ x: x, y: y, life: 1 });

      var moved = Math.abs(x - lastX) + Math.abs(y - lastY);
      if (moved > 3 && Math.random() < 0.5) {
        sparks.push({
          x: x, y: y,
          vx: (Math.random() - 0.5) * 1.2,
          vy: (Math.random() - 0.5) * 1.2 + 0.25,
          size: 0.8 + Math.random() * 1.4,
          life: 1
        });
      }
      lastX = x; lastY = y;
    }

    ctx.globalCompositeOperation = 'lighter';

    for (var i = trail.length - 1; i >= 0; i--) {
      var p = trail[i];
      p.life -= 0.045;
      if (p.life <= 0) { trail.splice(i, 1); continue; }
      glow(p.x, p.y, 4 + 16 * p.life, 0.22 * p.life);
    }

    for (var j = sparks.length - 1; j >= 0; j--) {
      var s = sparks[j];
      s.life -= 0.02;
      if (s.life <= 0) { sparks.splice(j, 1); continue; }
      s.x += s.vx; s.y += s.vy;
      ctx.fillStyle = 'rgba(255,255,255,' + s.life + ')';
      ctx.beginPath(); ctx.arc(s.x, s.y, s.size, 0, 6.2832); ctx.fill();
    }

    if (active) {
      glow(x, y, 26, 0.35);
      glow(x, y, 6, 0.9);
    }

    ctx.globalCompositeOperation = 'source-over';
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();